import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    openAddInvItem: false,
    invoiceItems: [],
    invoiceItemSelectedIndex: null,
    lastInvoiceItemSelectedIndex: null,
    invoiceVendors: [],
    invoiceVendorsLoaded: false,
    invoiceAcctNos: [],
    invoiceCustNames: [],
    invItemChargeDescs: [],
    invItemServiceAddrs: [],
    error: '',
    invoiceSubmitted: false,
    validatedVendorNAcctNo: false,
    validateError: null,
    docTemplLines: null,
    validatedVendorCode: null,
    validatedAcctNo: null,
    invoiceVendor: null,
    invoiceItem: null,
    invAcctNo: null,
    invoiceHeader: null,
    apolloItems: [],
    count: 0,
    page: 1,
    pageSize: 5,
    pages: 0,
    sortField: 'item_row_index',
    sortOrder: 'asc',
    anyChanges: false,
    vdpHdrDatasetId: null,
    taskAcceptedInfoId: null,
    apolloItem: null,
    totalSumOfItemCharge: 0,
    apolloItemId: null,
    fieldErrors: [],
}

const openAddNewInvItem = (state) => {
    return {
        ...state,
        openAddInvItem: true,
        apolloItem: null
    }
}

const cancelAddNewInvItem = (state)=>{
    return {
        ...state,
        openAddInvItem: false
    }
}

const addNewInvoiceItem = (state,action)=> {
    let invoiceItems=state.invoiceItems;
    invoiceItems.push(action.newInvoiceItem);
    return {
        ...state,
        invoiceItems: invoiceItems,
        openAddInvItem: false
    }
}

const updateEditInvoiceItem = (state,action)=> {
    let invoiceItems=state.invoiceItems;
    let updateInvItem=action.newInvoiceItem;
    invoiceItems[state.invoiceItemSelectedIndex]=updateInvItem;

    return {
        ...state,
        invoiceItems: invoiceItems,
        openAddInvItem: false,
        invoiceItemSelectedIndex: null
    }
}

const updateInvoiceItems = (state,action)=>{
    return {
        ...state,
        invoiceItems: action.invoiceItems,
        lastInvoiceItemSelectedIndex: null,
        invoiceItemSelectedIndex: null
    }
}

const invItemSelected = (state,action)=>{
    return {
        ...state,
        invoiceItemSelectedIndex: action.invoiceItemSelectedIndex,
        lastInvoiceItemSelectedIndex: action.invoiceItemSelectedIndex,
        invoiceItem: state.invoiceItems[action.invoiceItemSelectedIndex]
    }
}

const invItemDeselected = (state)=>{
    return {
        ...state,
        invoiceItemSelectedIndex: null,
        invoiceItem: null
    }
}

const updateInvoiceVendors = (state,action)=>{
    return {
        ...state,
        invoiceVendors: action.invoiceVendors,
        invoiceVendorsLoaded: true
    }
}

const updateApiError = (state,action)=> {
    return {
        ...state,
        error: action.error
    }
}

const invSubmittedSuccess = (state) => {
    return {
        ...state,
        invoiceSubmitted: true,
        error: '',
        invoiceItems: []
    }
}

const invSubmittedError = (state,action) => {
    return {
        ...state,
        error: action.error
    }
}

const invSubmittedCompleted = (state) => {
    return {
        ...state,
        invoiceSubmitted: false
    }
}

const validatedVendorNAcctNoSuccess = (state,action) => {
    return {
        ...state,
        validatedVendorNAcctNo: true,
        validateError: null,
        docTemplLines: action.docTemplLines,
        validatedVendorCode: action.validatedVendorCode,
        validatedAcctNo: action.validatedAcctNo
    }
}

const validatedVendorNAcctNoError = (state,action) => {
    return {
        ...state,
        validatedVendorNAcctNo: true,
        validateError: action.error
    }
}

const clearValidation = (state) => {
    return {
        ...state,
        validatedVendorNAcctNo: false,
        validateError: null,
        docTemplLines: null,
        validatedVendorCode: null,
        validatedAcctNo: null
    }
}

const selectedInvVendor = (state,action)=>{
    return {
        ...state,
        invoiceVendor: action.invoiceVendor
    }
}

const clearInvVendor = (state)=>{
    return {
        ...state,
        invoiceVendor: null
    }
}

const refreshInvoiceAcctNos = (state, action)=>{
    return {
        ...state,
        invoiceAcctNos: action.invoiceAcctNos
    }
}

const refreshInvoiceCustNames = (state, action)=>{
    return {
        ...state,
        invoiceCustNames: action.invoiceCustNames
    }
}

const refreshInvoiceItemChargeDescs = (state, action)=> {
    return {
        ...state,
        invItemChargeDescs: action.invItemChargeDescs
    }
}

const clearAllInvoiceItems = (state) => {
    return {
        ...state,
        invoiceItems: []
    }
}

const setInvAcctNo = (state,action)=>{
    return {
        ...state,
        invAcctNo: action.invAcctNo
    }
}

const clearInvAcctNo = (state)=>{
    return {
        ...state,
        invAcctNo: null
    }
}

const refreshInvoiceItemServiceAddress = (state, action)=> {
    return {
        ...state,
        invItemServiceAddrs: action.invItemServiceAddrs
    }
}

const saveInvoiceHeader=(state,action)=>{
    return {
        ...state,
        invoiceHeader: action.invoiceHeader
    }
}

const receivedApolloItems=(state,action)=>{
    const { apolloItems,count,page,pageSize,pages,sortField,sortOrder,vdpHdrDatasetId,taskAcceptedInfoId,totalSumOfItemCharge } = action.data;
    return {
        ...state,
        apolloItems: apolloItems,
        count: count,
        page: page,
        pageSize: pageSize,
        pages: pages,
        sortField: sortField,
        sortOrder: sortOrder,
        anyChanges: false,
        vdpHdrDatasetId: vdpHdrDatasetId,
        taskAcceptedInfoId: taskAcceptedInfoId,
        totalSumOfItemCharge: totalSumOfItemCharge,
        error: ''
    }
}

const getApolloItemsError=(state, action)=> {
    return {
        ...state,
        error: action.error
    }
}

const newApolloItemCreated=(state)=>{
    return {
        ...state,
        anyChanges: true,
        openAddInvItem: false
    }
}

const newApolloItemCreateError=(state,action)=>{
    return {
        ...state,
        error: action.error
    }
}

const editApolloItem=(state,action)=>{
    return {
        ...state,
        openAddInvItem: true,
        apolloItem: action.apolloItem
    }
}

const updatedApolloItem=(state)=>{
    return {
        ...state,
        openAddInvItem: false,
        apolloItem: null
    }
}

const updateApolloItemError=(state,action)=>{
    return {
        ...state,
        error: action.error
    }
}

const moveDownApolloItemSuccess=(state)=>{
    return {
        ...state,
        anyChanges: true,
        error: ''
    }
}

const moveDownApolloItemError=(state,action)=>{
    return {
        ...state,
        error: action.error
    }
}

const moveUpApolloItemSuccess=(state)=>{
    return {
        ...state,
        anyChanges: true,
        error: ''
    }
}

const moveUpApolloItemError=(state,action)=>{
    return {
        ...state,
        error: action.error
    }
}

const deletedApolloItemSuccess=(state)=>{
    return {
        ...state,
        anyChanges: true,
        error: ''
    }
}

const deletedApolloItemError=(state,action)=>{
    return {
        ...state,
        error: action.error
    }
}

const selectedApolloItemId=(state,action)=>{
    return {
        ...state,
        apolloItemId: action.id
    }
}

const updateFieldError = (state,action)=> {
    let fieldErrors=state.fieldErrors;
    action.adds.map(field => {
        if (fieldErrors.indexOf(field)<0) {
            fieldErrors.push(field);
        }
    })
    action.removes.map(field => {
        fieldErrors = fieldErrors.filter(f => f !== field)
    })
   
    return {
        ...state,
        fieldErrors: fieldErrors
    }
}

export default reduce(initialState,{
    [actionTypes.OPEN_ADD_INV_ITEM_FORM]: openAddNewInvItem,
    [actionTypes.CANCEL_ADD_INV_ITEM_FORM]: cancelAddNewInvItem,
    [actionTypes.ADD_NEW_INV_ITEM]: addNewInvoiceItem,
    [actionTypes.UPDATE_EDIT_INV_ITEM]: updateEditInvoiceItem,
    [actionTypes.INV_ITEM_SELECTED]: invItemSelected,
    [actionTypes.INV_ITEM_DESELECTED]: invItemDeselected,
    [actionTypes.UPDATE_INV_ITEMS]: updateInvoiceItems,
    [actionTypes.UPDATE_INV_VENDORS]: updateInvoiceVendors,
    [actionTypes.UPDATE_API_ERROR]: updateApiError,
    [actionTypes.INV_SUBMITTED_SUCCESS]: invSubmittedSuccess,
    [actionTypes.INV_SUBMITTED_ERROR]: invSubmittedError,
    [actionTypes.INV_SUBMITTED_COMPLETED]: invSubmittedCompleted,
    [actionTypes.INV_VALIDATE_VENDOR_N_ACCTNO_SUCCESS]: validatedVendorNAcctNoSuccess,
    [actionTypes.INV_VALIDATE_VENDOR_N_ACCTNO_ERROR]: validatedVendorNAcctNoError,
    [actionTypes.INV_CLEAR_VALIDATION]: clearValidation,
    [actionTypes.SELECTED_INV_VENDOR]: selectedInvVendor,
    [actionTypes.CLEAR_INV_VENDOR]: clearInvVendor,
    [actionTypes.REFRESH_INV_ACCT_NOS]: refreshInvoiceAcctNos,
    [actionTypes.REFRESH_INV_CUST_NAMES]: refreshInvoiceCustNames,
    [actionTypes.REFRESH_INV_CHARGE_DESCS]: refreshInvoiceItemChargeDescs,
    [actionTypes.CLEAR_ALL_INV_ITEMS]: clearAllInvoiceItems,
    [actionTypes.SET_INV_ACCT_NO]: setInvAcctNo,
    [actionTypes.CLEAR_INV_ACCT_NO]: clearInvAcctNo,
    [actionTypes.REFRESH_INV_SERVICE_ADDRESSES]: refreshInvoiceItemServiceAddress,
    [actionTypes.SAVE_INV_HEADER]: saveInvoiceHeader,
    [actionTypes.GET_APOLLO_ITEMS_SUCCESS]: receivedApolloItems,
    [actionTypes.GET_APOLLO_ITEMS_ERROR]: getApolloItemsError,
    [actionTypes.NEW_APOLLO_ITEM_CREATED]: newApolloItemCreated,
    [actionTypes.NEW_APOLLO_ITEM_CREATED_ERROR]: newApolloItemCreateError,
    [actionTypes.EDIT_APOLLO_ITEM]: editApolloItem,
    [actionTypes.UPDATED_APOLLO_ITEM_SUCCESS]: updatedApolloItem,
    [actionTypes.UPDATED_APOLLO_ITEM_ERROR]: updateApolloItemError,
    [actionTypes.MOVE_DOWN_APOLLO_ITEM_SUCCESS]: moveDownApolloItemSuccess,
    [actionTypes.MOVE_DOWN_APOLLO_ITEM_ERROR]: moveDownApolloItemError,
    [actionTypes.MOVE_UP_APOLLO_ITEM_SUCCESS]: moveUpApolloItemSuccess,
    [actionTypes.MOVE_UP_APOLLO_ITEM_ERROR]: moveUpApolloItemError,
    [actionTypes.DELETE_APOLLO_ITEM_SUCCESS]: deletedApolloItemSuccess,
    [actionTypes.DELETE_APOLLO_ITEM_ERROR]: deletedApolloItemError,
    [actionTypes.SELECTED_APOLLO_ITEM_ID]: selectedApolloItemId,
    [actionTypes.UPDATE_FIELD_ERROR]:updateFieldError
});


// WEBPACK FOOTER //
// ./src/redux/projApollo/reducer.js